import * as React from "react";
import { Col } from "react-bootstrap";
import { IParagraphMerchandisingBlockProps } from "./ParagraphMerchandisingBlockProps";
import {
  Container,
  CreditCard,
  PromotionLeftContainer,
  PromotionTitle,
  StyledRow,
} from "./ParagraphMerchandisingBlockHelpers";
import { graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";

const ParagraphMerchandisingBlock: React.FC<
  IParagraphMerchandisingBlockProps
> = (props) => {
  const field_link = props.node?.field_link;
  const altText = props.node?.field_image?.alt;
  const ctaDescription = props.node?.field_basic_title;
  const field_description_formatted = props.node?.field_description_formatted;
  const image = props.node?.relationships?.field_image
    ? getImage(props.node?.relationships?.field_image.gatsbyImage as any)
    : null;
  return (
    <Container>
      <StyledRow>
        <Col md={2} sm={12}>
          <CreditCard image={image} altText={altText} />
        </Col>
        <Col md={7} xs={12}>
          <PromotionTitle
            field_description_formatted={field_description_formatted}
          />
        </Col>
        <Col md={3} xs={12}>
          <PromotionLeftContainer
            field_link={field_link}
            ctaDescription={ctaDescription}
          />
        </Col>
      </StyledRow>
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphMerchandisingBlock on paragraph__merchandising_block {
    id
    field_basic_title
    field_link {
      title
      url
    }
    field_description_formatted {
      processed
    }
    field_image {
      alt
    }
    relationships {
      field_image {
        id
        publicUrl
        gatsbyImage(width: 136, height: 85, formats: [AUTO, WEBP])
      }
    }
  }
`;
export default ParagraphMerchandisingBlock;
